import untypedItems from "@data/items.json";

import type { Item, ItemsJson } from "@typings/product/item";

const items: ItemsJson = untypedItems as ItemsJson;

export default (itemId: number) => {
  return items[itemId];
};

export const getItemBySlug = (slug: string): Item => {
  return Object.values(items).find((i) => i.information.slug === slug);
};
